// extracted by mini-css-extract-plugin
export default {"content":"plaid-oauth-callback_content__SMall","pay":"plaid-oauth-callback_pay__oS+BT"};